<template>
    <div class="content-box">
         <div class="content">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">业务定制化</div>
                     <div class="title-e">BUSINESS CUSTOMIZATION</div>
                     <div class="title-line"></div>
                 </div>
             </div>
             <div class="describe">
                 新能源城市配送共享服务平为运力企业提供业务定制化服务，运力企业可结合企业自身的实际情况，定制化贴合企业业务模式的智慧物流系统，实现线上+线下完美结合。
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon441"></span> 合同创建
                 </div>
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon442"></span> 合同订单
                 </div>
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon443"></span> 合同流程
                 </div>
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon444"></span> 业务统计
                 </div>
             </div>

             <div class="img-describe img44"></div>
         </div>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>
<style src="./../../../styles/public-item.less" lang="less" scoped></style>